module.exports = new __parcel__URL__("ClickupSelectListIllustrationSpork.4e69219d.svg").toString();